if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/mindbox-services-worker.js')
}
